module.exports = __webpack_public_path__ + "img/ok-logo.8f5fcd4b.png";